import DQualifiedFExchangePage from './DQualifiedFExchangePage'

export default DQualifiedFExchangePage
